import { GREEN_500, BLUE_GREY_200 } from '@airtel/air-design-system';
export var photoVerificationConfig = {
  state: 'none',
  isExpanded: false,
  stepDetailsProps: {
    title: 'STEP 4',
    heading: 'Photo verification',
    avatarIcon: 'CameraOnIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  statusCardProps: {
    statusCardImage: {
      imageUrl: 'https://assets.airtel.in/static-assets/acq-skyc/photo-verification-bg.png'
    },
    subtitle: {
      text: 'Take photo in proper light & clear background. Ensure your head is straight, eye open and no garment/accessory covers your face.'
    },
    primaryCtaTitle: 'Open Camera',
    primaryButtonType: 'primary',
    ctaDirection: 'column-reverse',
    showCollapsible: false
  }
};
export var videoVerificationConfig = {
  state: 'none',
  isExpanded: false,
  stepDetailsProps: {
    title: 'STEP 5',
    heading: 'Video verification',
    avatarIcon: 'VideoCameraIcon',
    avatarProps: {
      style: {
        backgroundColor: BLUE_GREY_200
      }
    },
    actionType: 'button',
    actionTypeProps: {
      buttonText: 'Change'
    },
    actionTypePosition: 'center'
  },
  statusCardProps: {
    statusCardImage: {
      imageUrl: 'https://assets.airtel.in/static-assets/acq-skyc/video-verification-bg.png'
    },
    subtitle: {
      text: 'Record video in proper light & clear background. Ensure your head is straight, eye open and no garment/accessory covers your face.'
    },
    primaryCtaTitle: 'Open Camera',
    primaryButtonType: 'primary',
    ctaDirection: 'column-reverse',
    showCollapsible: false
  }
};
export var successAvatarConfig = {
  stepDetailsProps: {
    avatarIcon: 'TickButtonIcon',
    avatarProps: {
      style: {
        backgroundColor: GREEN_500
      }
    },
    subHeading: 'Uploaded successfullly',
    actionTypeProps: {
      buttonText: 'Preview'
    }
  }
};